import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { EVENT_STATUS_MAP, EVENT_STATUS_TEXT_MAP, SCHEDULE_STATUS_MAP } from '@src/mobile/constants';

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.locale('zh-cn');

export const getScrollTargetDate = (list) => {
    let targetDate = '';

    if (Array.isArray(list) && list.length) {
        const todayDate = dayjs(dayjs().format('YYYY-MM-DD'));

        for (const item of list) {
            const { date } = item;
            const itemDate = dayjs(date, 'YYYY-MM-DD');

            if (todayDate.isSameOrBefore(itemDate)) {
                targetDate = date;

                break;
            }
        }
    }

    return targetDate;
};

export const getScheduleDate = (date) => {
    const todayDate = dayjs(dayjs().format('YYYY-MM-DD'));
    const itemDate = dayjs(date, 'YYYY-MM-DD');
    const formatDate = itemDate.format('M月D日 dddd');
    const itemNextDate = itemDate.add(1, 'day');
    let dayType = SCHEDULE_STATUS_MAP.CURRENT;

    if (todayDate.isBefore(itemDate)) {
        dayType = SCHEDULE_STATUS_MAP.AFTER;
    } else if (todayDate.isSameOrAfter(itemNextDate)) {
        dayType = SCHEDULE_STATUS_MAP.BEFORE;
    }

    return { dayType, formatDate };
};

export const getHoursMinute = (date, time) => {
    const itemDate = dayjs(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss');

    return itemDate.format('HH:mm');
};

export const getEventDate = ({ date, time, dayType, isEnd, ucmsType, base62Id, url }) => {
    const itemDate = dayjs(`${date} ${time}`, 'YYYY-MM-DD HH:mm:ss');
    const formatTime = itemDate.format('HH:mm');
    let eventStatus = EVENT_STATUS_MAP.CURRENT;

    if (dayType === SCHEDULE_STATUS_MAP.BEFORE) {
        eventStatus = EVENT_STATUS_MAP.END;
    } else if (dayType === SCHEDULE_STATUS_MAP.AFTER) {
        eventStatus = EVENT_STATUS_MAP.NOT_START;
    } else if (dayType === SCHEDULE_STATUS_MAP.CURRENT) {
        if (isEnd) {
            eventStatus = EVENT_STATUS_MAP.END;
        } else {
            const nowDate = dayjs();
            const itemEndDate = itemDate.add(2, 'hour');

            if (nowDate.isBefore(itemDate)) {
                eventStatus = EVENT_STATUS_MAP.NOT_START;
            } else if (nowDate.isSameOrAfter(itemEndDate)) {
                eventStatus = EVENT_STATUS_MAP.END;
            }
        }
    }

    if (eventStatus === EVENT_STATUS_MAP.END && ucmsType && base62Id && url) {
        eventStatus = EVENT_STATUS_MAP.REPORT;
    }

    // 判断当前是小组赛还是淘汰赛
    const knockoutDate = dayjs('2022-12-03 23:00:00', 'YYYY-MM-DD HH:mm:ss');
    let eventTypeText = '';

    if (itemDate.isSameOrAfter(knockoutDate)) {
        eventTypeText = '世界杯淘汰赛';
    } else {
        eventTypeText = '世界杯小组赛';
    }

    return { formatTime, eventStatus, eventStatusText: EVENT_STATUS_TEXT_MAP[eventStatus], eventTypeText };
};

export const getKnockoutDate = (date) => {
    const itemDate = dayjs(date, 'YYYY-MM-DD');
    const formatItemDate = itemDate.format('MM.DD');

    return itemDate.isValid() ? formatItemDate : '待定';
};
